import superagent from 'superagent';
import authStore from './../store/authStore.js';
import commonStore from './../store/commonStore.js';
import authHandler from './auth';
import dataHandler from './data';

const API_ROOT = `/api`;

const handleErrors = err => {
  if (err && err.response && err.response.status === 401) {
    authStore.logout();
  }
};

const getBody = req => req.body;

const insertToken = req => {
  if (commonStore.token) {
    req.set('Authorization', `Bearer ${commonStore.token}`);
  }
};

const requests = {
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(insertToken)
      .on('error', handleErrors)
      .then(getBody),
  delete: url =>
    superagent
      .delete(`${API_ROOT}${url}`)
      .use(insertToken)
      .on('error', handleErrors)
      .then(getBody),
  post: (url, data) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(insertToken)
      .send(data)
      .set('Accept', 'application/json')
      .on('error', handleErrors)
      .then(getBody),
  put: (url, data) =>
    superagent
      .put(`${API_ROOT}${url}`)
      .use(insertToken)
      .send(data)
      .set('Accept', 'application/json')
      .on('error', handleErrors)
      .then(getBody),
  download: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(insertToken)
      .responseType('arraybuffer')
      .on('error', handleErrors)
      .then(getBody),
};

const Auth = authHandler(requests);
const Data = dataHandler(requests);

export default {
  Auth,
  Data,
};



// WEBPACK FOOTER //
// ./src/agent/index.js